export const getAIAnsweringModuleId = (): string => {

    if (process.env.VOICIFY_ENVIRONMENT == "dev" || process.env.VOICIFY_ENVIRONMENT == "staging") {
        return "1593985d-76f2-47c8-a3cd-2ac4609834eb";
    }
    else if (process.env.VOICIFY_ENVIRONMENT == "production") {
        return "15079da8-21fd-455c-8f49-96829bd1c558";
    }
    return null;

};

export const getFoodOrderingModuleId = (): string => {

    if (process.env.VOICIFY_ENVIRONMENT == "dev" || process.env.VOICIFY_ENVIRONMENT == "staging") {
        return "317a55ec-2015-4003-8bc6-9a0598f0f234";
    }
    else if (process.env.VOICIFY_ENVIRONMENT == "production") {
        return "8dd914fe-d6af-4fe4-9379-0cfc59be35ab";
    }
    return null;

};

export const getHealthcareSchedulingModuleId = (): string => {
    if (process.env.VOICIFY_ENVIRONMENT == "dev" || process.env.VOICIFY_ENVIRONMENT == "staging") {
        return "fd64785a-e49f-4d23-ac36-da162137ff75";
    }
    else if (process.env.VOICIFY_ENVIRONMENT == "production") {
        return "73c00abf-09d5-4640-8b81-1a0c391bef9c";
    }
    return null;

};